import React, { useState, useEffect, useMemo } from 'react';
import TranslatableDataGrid from '../shared/TranslatableDataGrid';
import StorefrontAdminTheme from '../shared/MUIStyles/StorefrontAdminTheme';
import { Typography, Select, ThemeProvider, Paper, Box, Button, TextField, MenuItem, InputLabel } from '@mui/material';
import { useStorefrontAdministrationConfig } from '../../hooks/StorefrontAdministrationConfigContext';
import { useStorefrontSettings } from '../../hooks/StorefrontSettingsContext';
import Storefront from '../../services/Storefront';
import Loading from '../Loading';
import { GridToolbarContainer, GridToolbarFilterButton, GridToolbarExport, GridToolbarDensitySelector } from '@mui/x-data-grid-premium';
import CheckIcon from '@mui/icons-material/Check';
import MUIAlertModal from '../shared/MUIAlertModal';
import DialogContentText from '@mui/material/DialogContentText';
import Notifications from '../../services/Notifications';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';


const BranchAdministration = () => {
    const theme = StorefrontAdminTheme;
    const localized = useStorefrontAdministrationConfig().labels;
    const storeData = useStorefrontSettings();
    const [rows, setRows] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [openAdd, setOpenAdd] = useState(false);
    const [branch, setBranch] = useState("");
    const [description, setDescription] = useState('');
    const [shown, setShown] = useState(false);
    const [branchError, setBranchError] = useState(false);
    const [descError, setDescError] = useState(false);
    const [openUpdate, setOpenUpdate] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [updateFlag, setUpdateFlag] = useState(true);
    const [addFlag, setAddFlag] = useState(true);
    const [branchList, setBranchList] = useState([]);



    useEffect(() => {
        const loadBranchList = async () => {
            await getBranchList();
        };
        loadBranchList();
    }, []);
    const getBranchList = async () => {
        setFetching(true);
        var rows = [];
        await Storefront.getBrachList(storeData.storefrontNumber).then((data) => {
            if (data) {
                const brSFItem = data.filter(x => x.storefrontId == storeData.storefront.id);
                brSFItem.forEach((br) => {
                    rows.push({
                        id: br.id,
                        number: br.number,
                        description: br.description,
                        shown: br.shown,
                        isDefault: br.isDefault,
                        isPreferenceDefault: br.isPreferenceDefault
                    });
                });
                setRows(rows);
                setBranchList(data);
            }
            else {
                setRows([]);
                setBranchList([]);
            }
            setFetching(false);
        });
    }
    const handleShownChange = (event) => {
        if (!descError) {
            setUpdateFlag(false);
        }       
        setShown(event.target.value === true);
    };
    const handleChange = (event) => {
        setBranch(event.currentTarget.value);
        if (event.currentTarget.value != "") {
            setBranchError(false);
            if (description != "") {
                setAddFlag(false);
            }
        }
    };

    const handleDescChange = (event) => {
        setDescription(event.currentTarget.value);
        if (event.currentTarget.value != "") {
            setDescError(false);
            if (branch != "" && !branchError) {
                setAddFlag(false);
            }
        }

    };
    const handleDescBlur = async () => {
        if (description == '') {
            setDescError(true);
        }
        else {
            if (branchList.filter(x => x.description == description).length != 0) {
                setDescError(true);
                setAddFlag(true);
                Notifications.error(localized.BranchDescriptionDuplicate);
            }
            else {
                setDescError(false);
                if (!branchError)
                setAddFlag(false);
            }
        }
    }
    const handleUpdateDescChange = (event) => {
        setDescription(event.currentTarget.value);
        if (event.currentTarget.value != "") {
            setUpdateFlag(false);
            setDescError(false);
            setUpdateFlag(false);          
        }
        else {
            if (branchList.filter(x => x.description == description).length != 0) {
                setDescError(true);
                setUpdateFlag(true);
                Notifications.error(localized.BranchDescriptionDuplicate);
            }
        }
    };
    const handleUpdateDescBlur = async (num, desc) => {
        if (description == '') {
            setDescError(true);
        }
        else {
            const selected = branchList.find(x => x.description == description);
           if (selected && selected.number != num) {
                setDescError(true);              
                setUpdateFlag(true);
                Notifications.error(localized.BranchDescriptionDuplicate);
            }
           else {
               setDescError(false);               
               setUpdateFlag(false);
           }
        }
    }
    const handleCloseUpdate = () => {
        setOpenUpdate(false);
        setDescription('');
        setDescError(false);
        setShown(false);
    };
    const handleDescPaste = (e) => {
        e.preventDefault();
        const pastedText = e.clipboardData.getData("text")?.trim() || "";
        setDescription(pastedText);
        e.target.value = pastedText;
    };
    const handleDescKeyDown = async (e) => {
        if (e.key === "Tab" || e.key == 'Enter') {
            if (branch != "") {
                const selected = branchList.find(x => x.description == description);
                if (selected && selected.number != branch) {
                    setDescError(true);
                    setAddFlag(true);
                    setUpdateFlag(true);
                    Notifications.error(localized.BranchDescriptionDuplicate);
                }
            }

        }
    }
    const handleBranchPaste = (e) => {
        e.preventDefault();
        const pastedText = e.clipboardData.getData("text")?.trim() || "";
        setBranch(pastedText);
        e.target.value = pastedText;
    };
    const handleBranchKeyDown = async (e) => {
        if (e.key === "Tab" || e.key == 'Enter') {
            if (branch != "") {
                if (branchList.some(x => x.number === branch)) {
                    setBranchError(true);
                    setAddFlag(true);
                    Notifications.error(localized.BranchDuplicate);
                }
            }

        }
    }    
    const handleBranchBlur = async () => {
        let defaultBranch = false;
        if (branch.startsWith('0') && (branch == storeData.storefront.number) ) {
            defaultBranch = true;
        }       
        else {
            defaultBranch = branch == storeData.storefront.number.slice(1) ;
        }
        if (branch == '') {
            setBranchError(true);
        }
        else if (defaultBranch) {
            setBranchError(true);
            setAddFlag(true);
            Notifications.error("Storefront Number not allowed to create as branch");
        }
        else {
            if (branchList.filter(x => x.number == branch).length != 0 && !branchError) {
                setBranchError(true);
                setAddFlag(true);
                Notifications.error(localized.BranchDuplicate);
            }
        }
    }
    const handleClickOpenAdd = () => {
        setAddFlag(true);
        setOpenAdd(true);
    };

    const handleCloseAdd = () => {
        setOpenAdd(false);
        setBranch('');
        setBranchError(false);
        setDescription('');
        setDescError(false);
        setShown(false);

    };

    const handleClickOpenDelete = (e, row) => {
        e.stopPropagation();
        setSelectedRow(row);
        setOpenDelete(true);
    };

    const handleClickOpenUpdate = (e, row) => {
        e.stopPropagation();
        setDescription(row.description);
        setShown(row.shown);
        setSelectedRow(row);
        setUpdateFlag(true);
        setOpenUpdate(true);
    };

    const addBranch = async (type) => {
        var request = {
            number: branch ?? null,
            description: description ?? null,
            storefrontId: storeData.storefront.id,
            shown: shown ?? null,
            operationType: type
        };
        return await Storefront.updateBranchItems(request).then((res) => {
            if (res.response.endsWith("Success"))
                Notifications.message(localized.BranchAddConfirmation);
            else
                Notifications.error(localized.BranchUpdateDeleteError);

            getBranchList();
        });
    }

    const handleCloseDelete = () => {
        setOpenDelete(false);
    };
    const updateBranch = async (form, type) => {
        if (type == 'add') {          
            if (!branchError && !descError) {
                addBranch(type);
            }
            else {
                Notifications.error(localized.BranchUpdateDeleteError);
            }

        }
        else {
            if (type == 'delete' || (type == 'update')) {
                var request = {
                    number: form.Number ?? null,
                    description: description ?? null,
                    shown: shown == '' ? false : shown,
                    operationType: type
                };
                return await Storefront.updateBranchItems(request).then((res) => {
                    if (res) {
                        const notificationType = res.response.endsWith("Success") ? "message" : "error";

                        if (notificationType == 'message') {
                            if (type == "delete") {
                                Notifications.message(localized.BranchDelete);
                            }
                            else
                                Notifications.message(localized.BranchUpdate);
                        }
                        else {
                            Notifications.error(localized.BranchUpdateDeleteError);
                        }
                        getBranchList();
                    }
                });
            }
        }
    }
    const columns = [
        {
            field: 'number',
            headerName: localized.Branch,
            headerAlign: 'left',
            flex: 1
        },
        {
            field: 'description',
            headerName: localized.StorefrontAdminDescription,
            headerAlign: 'left',
            flex: 1
        },
        {
            field: 'shown',
            headerName: localized.BranchShown,
            headerAlign: 'left',
            align: 'center',
            flex: 1,
            renderCell: (params) => {
                return (
                    <strong>
                        {params.row.shown ? (params.value === true ? <CheckIcon style={{ color: "rgb(56, 178, 95)" }} /> : null) : params.value}
                    </strong>
                )
            }
        },
        {
            field: 'isDefault',
            headerName: localized.BranchDefault,
            headerAlign: 'left',
            align: 'center',
            flex: 1,
            renderCell: (params) => {
                return (
                    <strong>
                        {params.row.isDefault ? (params.value === true ? <CheckIcon style={{ color: "rgb(56, 178, 95)" }} /> : null) : params.value}
                    </strong>
                )
            }
        },
        {
            field: 'isPreferenceDefault',
            headerName: localized.BranchPreferenceDefault,
            headerAlign: 'left',
            align: 'center',
            flex: 1,
            renderCell: (params) => {
                return (
                    <strong>
                        {params.row.isPreferenceDefault ? (params.value === true ? <CheckIcon style={{ color: "rgb(56, 178, 95)" }} /> : null) : params.value}
                    </strong>
                )
            }
        },
        {
            field: 'updateButton',
            headerName: localized.StorefrontAdminUpdate,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                return (
                    <strong>
                        <Button
                            variant="standard"
                            color="update"
                            disabled={params.row.isDefault}
                            style={{ marginLeft: 16 }}
                            onClick={(e) => handleClickOpenUpdate(e, params.row)}
                        >
                            {localized.StorefrontAdminUpdate}
                        </Button>
                    </strong>
                )
            },
            disableClickEventBubbling: true

        },
        {
            field: 'deleteButton',
            headerName: localized.StorefrontAdminDelete,
            headerAlign: 'center',
            align: 'center',
            headerClassName: 'columnTopper',
            renderCell: (params) => {
                return (
                    <strong>
                        <Button
                            variant="standard"
                            color="error"
                            disabled={params.row.isDefault}
                            style={{ marginLeft: 16 }}
                            onClick={(e) => handleClickOpenDelete(e, params.row)}
                        >
                            {localized.StorefrontAdminDelete}
                        </Button>
                    </strong>
                )
            },
            disableClickEventBubbling: true
        }
    ];
    const customToolbar = () => {
        return (
            <GridToolbarContainer>
                <Box sx={{ flexGrow: 1 }} />
                <GridToolbarFilterButton
                    slotProps={{
                        tooltip: { title: 'Filter list' }
                    }}
                    variant="outlined"
                    color="update"
                />
                <GridToolbarDensitySelector
                    slotProps={{
                        tooltip: { title: 'Change density' }
                    }}
                    variant="outlined"
                    color="update"
                />

                <GridToolbarExport
                    printOptions={{ disableToolbarButton: true }}
                    slotProps={{
                        tooltip: { title: 'Export data' }
                    }}
                    variant="outlined"
                    color="update"
                />
                {renderAddButton()}
            </GridToolbarContainer>
        );
    }
    const renderAddButton = () => (
        <strong>
            <Button
                variant="contained"
                color="success"
                style={{ marginLeft: 16 }}
                onClick={handleClickOpenAdd}
            >
                {localized.StorefrontAdminAdd}
            </Button>
        </strong>
    );
    const renderAddModal = (row) => {
        return (
            <>
                <Dialog
                    open={openAdd}
                    onClose={handleCloseAdd}
                    maxWidth="lg"                  
                    PaperProps={{
                        component: 'form',
                        onSubmit: (event) => {
                            event.preventDefault();
                            const formData = new FormData(event.currentTarget);
                            const formJson = Object.fromEntries(formData.entries());
                            updateBranch(formJson, "add");
                            handleCloseAdd();
                        },

                    }}

                >
                    <DialogTitle><h1>{localized.AddBranchHeader}</h1></DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <h3>{localized.BranchDCXConfirmation}</h3>
                            <h5>{localized.FillRequiredFieldsBelow}</h5>
                        </DialogContentText>
                        <>
                            <TextField
                                value={branch}
                                required
                                id="branchNumber"
                                name="branchNumber"
                                label={localized.Branch}
                                type="text"
                                fullWidth
                                onBlur={handleBranchBlur}
                                variant="standard"
                                error={branchError}
                                onChange={handleChange}
                                inputProps={{
                                    maxLength: 50,
                                    onPaste: handleBranchPaste,
                                    onKeyDown: handleBranchKeyDown,
                                }}
                            />
                            <TextField
                                value={description}
                                required
                                id="branchDesc"
                                name="branchDesc"
                                label={localized.StorefrontAdminDescription}
                                type="text"
                                fullWidth
                                onBlur={handleDescBlur}
                                variant="standard"
                                error={descError}
                                onChange={handleDescChange}
                                inputProps={{
                                    maxLength: 50,
                                    onPaste: handleDescPaste,
                                    onKeyDown: handleDescKeyDown,
                                }}
                            />
                            <InputLabel id="value-label">{localized.BranchShown}</InputLabel>
                            <Select
                                required
                                fullWidth
                                labelId="value-label"
                                id="value"                               
                                value={shown}
                                label={localized.IsEnabled}
                                onChange={handleShownChange}
                            >
                                <MenuItem value={true}>{localized.True}</MenuItem>
                                <MenuItem value={false}>{localized.False}</MenuItem>
                            </Select></>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="standard" color="error" onClick={handleCloseAdd}>{localized.StorefrontAdminCancel}</Button>
                        <Button variant="standard" color="success" type="submit" disabled={addFlag}>{localized.StorefrontAdminAdd}</Button>
                    </DialogActions>
                </Dialog>
            </>
        )
    }

    const renderUpdateModal = (row) => {
        return (
            <>
                <Dialog
                    open={openUpdate}
                    onClose={handleCloseUpdate}
                    PaperProps={{
                        component: 'form',
                        onSubmit: (event) => {
                            event.preventDefault();
                            const formData = new FormData(event.currentTarget);
                            formData.append("Number", row.number);
                            formData.append("Shown", row.shown);
                            formData.append("Desc", row.description);

                            const formJson = Object.fromEntries(formData.entries());
                            updateBranch(formJson, "update");
                            handleCloseUpdate();
                        },

                    }}
                    maxWidth="lg"
                >
                    <DialogTitle>  <Typography variant="h5" component="h1">
                        {localized.BranchUpdateHeader} </Typography></DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <h3>{localized.BranchDCXConfirmation}</h3>
                            <h4>{localized.FillRequiredFieldsBelow}</h4>
                        </DialogContentText>
                        <>
                            <TextField
                                disabled
                                id="standard-disabled"
                                label={localized.Branch}
                                defaultValue={row.number}
                                variant="standard"
                                fullWidth
                                inputProps={{ maxLength: 50 }}
                            />
                            <TextField
                                value={description}
                                required
                                id="branchDesc"                             
                                label={localized.StorefrontAdminDescription }
                                type="text"
                                fullWidth
                                onBlur={() => handleUpdateDescBlur(row.number, row.description)}
                                variant="standard"
                                error={descError}
                                onChange={handleUpdateDescChange}
                                inputProps={{
                                    maxLength: 50,
                                    onPaste: handleDescPaste,
                                    onKeyDown: handleDescKeyDown,
                                }}
                            />
                            <InputLabel id="value-label">{localized.BranchShown}</InputLabel>
                            <Select
                                required
                                fullWidth
                                labelId="value-label"
                                id="value"                              
                                value={shown}
                                label={localized.IsEnabled}
                                onChange={handleShownChange}
                            >
                                <MenuItem value={true}>{localized.True}</MenuItem>
                                <MenuItem value={false}>{localized.False}</MenuItem>
                            </Select></>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="standard" color="error" onClick={handleCloseUpdate}>{localized.StorefrontAdminCancel}</Button>
                        <Button variant="standard" color="update" type="submit" disabled={updateFlag}>{localized.StorefrontAdminUpdate}</Button>
                    </DialogActions>
                </Dialog>
            </>
        )
    }

    const renderDeleteButton = (row) => (
        <MUIAlertModal
            open={openDelete}
            onClose={handleCloseDelete}
            title={localized.AreYouSure}
            message={
                <>
                    <h3>{localized.AreYouSureBranchDeleteConfirmation}</h3>
                    <DialogContentText>
                        <b>{row.code}</b>
                    </DialogContentText>
                </>
            }
            confirmLabel={localized.StorefrontAdminDelete}
            cancelLabel={localized.StorefrontAdminCancel}
            onConfirm={(event) => {
                event.preventDefault();
                const formData = new FormData(event.currentTarget);
                formData.append("Number", row.number);
                const formJson = Object.fromEntries(formData.entries());
                updateBranch(formJson, "delete");
                handleCloseDelete();
            }}
            confirmButtonProps={{ color: "error" }}
            cancelButtonProps={{ color: "update" }}
        />
    );

    const branchItems = useMemo(() => {
        return (
            <Paper sx={{ height: 700, width: '100%' }}>
                <TranslatableDataGrid rows={rows} columns={columns} insetToolbar={customToolbar} labels={localized} />
            </Paper>
        );
    }, [rows, localized]);
    return (
        <>
            {
                fetching && <Loading type="brand" />
            }
            {
                !fetching && (localized && Object.keys(localized).length > 0) &&
                <>
                    <ThemeProvider theme={theme}>
                        <Typography variant="h1">{localized.BranchAdministrationHeader}</Typography>
                        {branchItems}
                        {openUpdate && renderUpdateModal(selectedRow)}
                        {openDelete && renderDeleteButton(selectedRow)}
                        {openAdd && renderAddModal()}
                    </ThemeProvider>
                </>
            }
        </>
    );
};
export default BranchAdministration